import { FacebookShareButton, TwitterShareButton, PinterestShareButton, LinkedinShareButton } from 'react-share';
import { Icon } from "../../Icon/Icon/Icon";
import styles from "./SocialBlockArticle.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SocialBlockArticle = function SocialBlockArticle(_ref) {
  var url = _ref.url,
    title = _ref.title,
    media = _ref.media,
    facebook = _ref.facebook,
    twitter = _ref.twitter,
    pinterest = _ref.pinterest,
    linkedin = _ref.linkedin,
    socialLabels = _ref.socialLabels;
  var renderIcon = function renderIcon(networkName) {
    return /*#__PURE__*/_jsx("div", {
      className: styles.icon,
      "data-e2e-name": "social_block_article_icon",
      children: /*#__PURE__*/_jsx(Icon, {
        height: "32px",
        type: "social-".concat(networkName, "-round"),
        width: "32px"
      })
    });
  };
  var renderIcons = function renderIcons() {
    var _ref2 = socialLabels || {},
      facebookLabel = _ref2.facebookLabel,
      twitterLabel = _ref2.twitterLabel,
      pinterestLabel = _ref2.pinterestLabel,
      linkedinLabel = _ref2.linkedinLabel;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [facebook && /*#__PURE__*/_jsx(FacebookShareButton, {
        url: url,
        quote: title,
        "data-e2e-name": "social_facebook",
        "aria-label": facebookLabel,
        className: styles.iconWrapper,
        children: renderIcon('facebook')
      }), twitter && /*#__PURE__*/_jsx(TwitterShareButton, {
        url: url,
        title: title,
        "data-e2e-name": "social_twitter",
        "aria-label": twitterLabel,
        className: styles.iconWrapper,
        children: renderIcon('twitter')
      }), media && pinterest && /*#__PURE__*/_jsx(PinterestShareButton, {
        url: url,
        media: media,
        description: title,
        "data-e2e-name": "social_pinterest",
        "aria-label": pinterestLabel,
        className: styles.iconWrapper,
        children: renderIcon('pinterest')
      }), linkedin && /*#__PURE__*/_jsx(LinkedinShareButton, {
        url: url,
        title: title,
        "data-e2e-name": "social_linkedin",
        "aria-label": linkedinLabel,
        className: styles.iconWrapper,
        children: renderIcon('linkedin')
      })]
    });
  };
  if (!facebook && !twitter && !media && !pinterest && !linkedin) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    className: styles.socialBlockArticle,
    "data-e2e-name": "social_block_article",
    children: renderIcons()
  });
};